// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1KmrD","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__17Tc_"};